/* global process */
import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import globalEvent from './modules/global-event'
import device from './modules/device'
import user from './modules/user'
import hero from './modules/hero'
import gameSocket from './modules/game-socket'
import battle from './modules/battle'
import gameData from './modules/game-data'
import freeConfig from './modules/free-config'
import fuben from './modules/fuben'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    globalEvent,
    device,
    user,
    hero,
    battle,
    gameSocket,
    gameData,
    freeConfig,
    fuben,
  },
  strict: debug
})
